/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component } from "react";

import CSVViewer from "../CSV/CSVViewer";
import EXCELViewer from "../EXCEL/EXCELViewer";
import IconButton from '@material-ui/core/IconButton'
class TABLEViewer extends Component {
  state = {
      download: false,
      ishighlightOn : false

  };

  componentDidMount(){
    let { params } = this.props;
    let ishighlightOn = params.findIndex((element) => element.key === 'highlight') !== -1 ? params.find((element) => element.key === 'highlight').value.boolean : false
    let download = false;
    if( params.find((element) => element.key === 'download') ) {
        download  = params.find((element) => element.key === 'download').value.boolean;
    }
    
      this.setState({ download : download, ishighlightOn : ishighlightOn})
  }

  componentDidUpdate() {
    console.log("Table Viewer Props Updated");
  }
  /************ props to required values extraction for "csv" type viewers*******************/
  getSelectedRowForCSV = () => {
    try {
      let selectedRow;
      //if group is not null then look in group
      if (this.props.record.group) {
        selectedRow = this.props.record.group[this.props.location_index]
          .iu_record_src_info.iu_record_nav_info.location.position;
      } else {
        selectedRow = this.props.record.iu_record_src_info.iu_record_nav_info
          .location.position;
      }
      return selectedRow;
    } catch (err) {
      console.log(err);

      return 0;
    }
  };

  /************ props to required values extraction for "xls" and "xlsx" type viewers*******************/
  //returns selected cell range computed from props.record

  numToSSColumnLetter = (num) => {
    let columnLetter = "",
      t;
  
    while (num > 0) {
      t = (num - 1) % 26;
      columnLetter = String.fromCharCode(65 + t) + columnLetter;
      num = (num - t) / 26 | 0;
    }
    return columnLetter || undefined;
  }


  getCellRange = () => {
    try {
      let cellRange;
      //if group is not null then look in group
      if (this.props.record.group) {
        cellRange = this.props.record.group[this.props.location_index]
          .iu_record_src_info.iu_record_nav_info.location.position;
      } else {
        cellRange = this.props.record.iu_record_src_info.iu_record_nav_info
          .location.position;
      }
      return cellRange;
    } catch (err) {
      console.log("Selected Cell Range :: Default : ", "A1:" + this.numToSSColumnLetter(this.props.drl_result[0].max_column) + "1")
      return "A1:" + this.numToSSColumnLetter(this.props.drl_result[0].max_column) + "1";
    }
  };

  //returns hdr range computed from props.record
  getHdrRange = () => {
    try {
      let hdrRange;
      //if group is not null then look in group
      if (this.props.record.group) {
        hdrRange = this.props.record.group[this.props.location_index]
          .iu_record_src_info.iu_record_nav_info.source[2].link;
      } else {
        hdrRange = this.props.record.iu_record_src_info.iu_record_nav_info
          .source[2].link;
      }
      return hdrRange;
    } catch (err) {
      return "A1:" + this.numToSSColumnLetter(this.props.drl_result[0].max_column) + "1";
    }
  };

  getSelectedRowForXLS = () => {
    try {
      //cell range will be in format "A7:E7"
      let cellRange = this.getCellRange();
      console.log("Selected Cell Range :: ", cellRange)
      let startCell = cellRange.split(":")[0];
      let endCell = cellRange.split(":")[1];
      //reverse to extract row nos
      let startRowNo = startCell.match(/\d+/)[0];
      let endRowNo = endCell.match(/\d+/)[0];
      //currently we assume that only 1 line(either a row or column ) can be selected
      if (startRowNo === endRowNo) {
        return startRowNo;
      } else return null;
    } catch (err) {
      console.log(err);

      return 1;
    }
  };
  //compute selected row,from "Cell Range" in iu record location
  getSelectedCol = () => {
    try {
      //cell range will be in format "A7:E7"
      let cellRange = this.getCellRange();
      let startCell = cellRange.split(":")[0];
      let endCell = cellRange.split(":")[1];
      //reverse to extract row nos
      let startRowNo = startCell.match(/\d+/)[0];
      let endRowNo = endCell.match(/\d+/)[0];
      //currently we assume that only 1 line(either a row or column ) can be selected
      if (startRowNo === endRowNo) {
        return null;
      } else {
        //compute col num as string from either start or end
        return startCell.replace(String(startRowNo), "");
      }
    } catch (err) {
      console.log(err);

      return 0;
    }
  };

  //compute header row, from "Table Header" in iu record source
  getHdrRow = () => {
    try {
      let hdrRange = this.getHdrRange();
      let startCell = hdrRange.split(":")[0];
      let endCell = hdrRange.split(":")[1];
      //reverse to extract row nos
      let startRowNo = startCell.match(/\d+/)[0];
      let endRowNo = endCell.match(/\d+/)[0];
      //currently we assume that only 1 line(either a row or column ) can be selected
      if (startRowNo === endRowNo) {
        return startRowNo;
      } else return null;
    } catch (err) {
      console.log(err);
      return 0;
    }
  };

  //compute header column, from "Table Header" in iu record source
  getHdrClm = () => {
    try {
      let hdrRange = this.getHdrRange();
      let startCell = hdrRange.split(":")[0];
      let endCell = hdrRange.split(":")[1];
      //reverse to extract row nos
      let startRowNo = startCell.match(/\d+/)[0];
      let endRowNo = endCell.match(/\d+/)[0];
      //currently we assume that only 1 line(either a row or column ) can be selected
      if (startRowNo === endRowNo) {
        return null;
      } else return startCell.replace(String(startRowNo), "");
    } catch (err) {
      console.log(err);
      return 0;
    }
  };

  /*
    compute table orientation, from "Table Header" in iu record source 
    1. "horizontal": header is first row
    2. "veritcal": header is first column
    3. "vertical_reverse": header is last column(Ex: used in arabic )
    */
  getOrientation = () => {
    try {
      let hdrRow = this.getHdrRow();
      if (hdrRow !== null) {
        return "horizontal";
      } else {
        let hdrClm = this.getHdrClm();
        if (hdrClm !== null) return "vertical";
        else return null;
      }
    } catch (err) {
      console.log(err);
      return "";
    }
  };
  //compute selected work sheet name, from "Workssheet" in iu record source
  getSelectedWorkSheetName = () => {
    try {
      let worksheetName;
      //if group is not null then look in group
      if (this.props.record.group) {
        worksheetName = this.props.record.group[this.props.location_index]
          .iu_record_src_info.iu_record_nav_info.source[1].link;
      } else {
        worksheetName = this.props.record.iu_record_src_info.iu_record_nav_info
          .source[1].link;
      }
      return worksheetName;
    } catch (err) {
      console.log(err);
      return this.props.drl_result[0].name;
    }
  };

  //get sub type of table, can be "csv" ,"xls" or "xlsx"
  getSubType = () => {
    try {
      let subType;
      //if group is not null then look in group
      if (this.props.record.group) {
        subType = this.props.record.group[this.props.location_index]
          .iu_record_src_info.iu_content_type.sub_type;
      } else {
        subType = this.props.record.iu_record_src_info.iu_content_type.sub_type;
      }
      return subType;
    } catch (err) {
      console.log(err);
      return "";
    }
  };

  shouldIncludeHeaders = () => {
    let header_info
    if (this.props.record.group) {
      header_info = this.props.record.group[this.props.location_index]
        .iu_record_src_info.iu_record_nav_info.source[2] !== undefined ? true : false;
    } else {
      if (this.props.record.iu_record_src_info.iu_record_nav_info.source) {
        header_info = this.props.record.iu_record_src_info.iu_record_nav_info.source[2] !== undefined ? true : false;
      }
    }

    if (header_info) {
      return true
    } else {
      return false
    }
  }

  renderViewer = () => {
    let subType = this.getSubType();
    if (subType === "csv") {
      return (
        <CSVViewer
          selectedRow={this.getSelectedRowForCSV()}
          width={this.props.width}
          height={this.props.height}
          fileLink={this.props.drl_result.file_link}
          workSheets={this.props.drl_result.work_sheets}
          selectedWorkSheetName=""
          drlUrl={this.props.drl_url}
          downloadUrl={
            this.props.drl_url + "/" + this.props.drl_result.src_file_link
          }
          download={this.state.download}
          filename = { this.props.record.source_link.src_file_name }
        />
      );
    }
    if (subType === "xls" || subType === "xlsx") {
      console.log("drl_result excel", this.props.drl_result);
      return (
        <EXCELViewer
          selectedRow={this.getSelectedRowForXLS()}
          selectedCol={this.getSelectedCol()}
          shouldIncludeHeaders = {this.shouldIncludeHeaders()}
          headerRow={this.getHdrRow()}
          headerColumn={this.getHdrClm()}
          width={this.props.width}
          height={this.props.height}
          workSheets={this.props.drl_result}
          orientation={this.getOrientation()}
          selectedWorkSheetName={this.getSelectedWorkSheetName()}
          drlUrl={this.props.drl_url}
          fileType={subType}
          downloadUrl={
            this.props.drl_url + "/" + this.props.drl_result[0].src_file_link
          }
          download={this.state.download}
          filename = { this.props.record.source_link.src_file_name }
        ></EXCELViewer>
      );
    }
  };

  render() {
    console.log("table viewer", this.props);
    return (
      <div
        style={{
          width: this.props.width,
          height: this.props.height,
          backgroundColor: "#FAFBFC",
        }}
      >
        {this.renderViewer()}
      </div>
    );
  }
}

export default TABLEViewer;
